<template>
  <v-dialog :value="isActive" persistent :width="options.width">
    <v-card :color="options.color">
      <v-card-title>{{ options.title }}</v-card-title>
      <v-card-text v-if="options.text">
        <!-- v-html 属性 -->
        {{ options.text }}
        <v-text-field v-model="prompt_text"></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close_modal" text>取消</v-btn>
        <v-btn @click="close_modal" text>确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "wtk-prompt",
  data: () => ({
    prompt_text: "",
  }),
  computed: {
    isActive() {
      return this.$store.getters["message/prompt"].isActive;
    },
    options() {
      return this.$store.getters["message/prompt"].options;
    },
  },
  methods: {
    close_modal() {
      var params = { type: "confirm", args: this.prompt_text };
      this.$store.dispatch("message/hide", params.type);
      this.$store.dispatch("message/callback", params);
      this.prompt_text = "";
    },
  },
};
</script>